export default function DoctioAssist() {
  return (
    <div className="container mt-20 mx-auto">
      <div>
        <h4 className="text-dxl md:text-d2xl font-bold text-doctio-green">
          Doctio Assist en genvejsfunktion
        </h4>

        <p>
          Doctio Assist er en genvejsfunktion, der giver mulighed for hurtigt og
          nemt at indsætte fraser eller standardfraser fra Doctio i et
          journalnotat. Funktionen kan aktiveres enten fra en valgt frase i
          fraseoversigten eller fra et tomt journalnotat. Der er ingen
          begrænsning for, hvor mange fraser der kan indsættes i et notat,
          hvilket gør det muligt at kombinere forskellige fraser eller korte
          tekststykker, også kaldet delfraser, såsom objektive undersøgelser,
          behandlingsplaner eller patientinformationer, til et komplet
          journalnotat. Det er derfor praktisk at have en mappe med fraser til
          disse delelementer.
        </p>

        <p>
          Doctio Assist aktiveres ved at skrive "." efterfulgt af den ønskede
          frase med et mellemrum. Funktionen søger både på frasens navn samt
          tilknyttede tags i hele biblioteket, herunder brugerens egne fraser,
          abonnementsfraser og Doctios standardfraser.
        </p>

        <p>
          Et eksempel med en frase for brystsmerter demonstrerer brugen af
          Doctio Assist. Når man står i et tomt notat og skriver ".", efterfulgt
          af "brystsmerter" uden mellemrum, vises en liste med relevante fraser.
          Ved at navigere ned til "brystsmerter" og vælge den ønskede frase,
          indsættes den i notatet, klar til at blive udfyldt.
        </p>

        <p>
          Desuden kan man nemt tilføje andre fraser eller tekststykker i frasen
          ved hjælp af autosuggestion. Ved at skrive ".stp" og vælge "stetoskopi
          pulmones" indsættes en frase for stetoskopi af lungerne.
          Autosuggestion gør det dermed nemt at indsætte hele fraser eller
          kombinere flere små fraser til et komplet journalnotat hurtigt og
          nemt.
        </p>
      </div>

      <div className="mt-10">
        <iframe
          width="560"
          height="315"
          className="h-[200px] md:h-[600px]"
          style={{ width: "100%", borderRadius: "10px" }}
          src="https://www.youtube.com/embed/Hucy3qzJZEk?si=ryXTaLGNJxOlcHqe"
          title="YouTube video player"
          frameBorder={0}
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowFullScreen={true}
        ></iframe>
      </div>
    </div>
  );
}
